import { ComponentType } from "react";
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider as MuiProvider } from "@material-ui/core/styles";
import { ThemeProvider as EmotionProvider } from "emotion-theming";

import theme from "theme";

export const withTheme = <P extends Record<string, unknown>>(
  Component: ComponentType<P>,
) => (props: P) => (
  <MuiProvider theme={theme}>
    <CssBaseline />
    <EmotionProvider theme={theme}>
      <Component {...(props as P)} />
    </EmotionProvider>
  </MuiProvider>
);

export default withTheme;
